"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colorutils997790c = require("./colorutils-997790c4.js");

require("./chunk-76875e58.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: inline-block;\n  margin: 3px;\n  background-color: ", ";\n  width: 25px;\n  height: 25px;\n  border: 3px solid white;\n  border-radius: 25px;\n  &:hover {\n    cursor: pointer;\n    box-shadow: 0 0 0 2px ", ";\n  }\n  &.selected {\n    box-shadow: 0 0 0 2px ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ColorPickerSwatches = function ColorPickerSwatches(_ref) {
  var swatches = _ref.swatches,
      hex = _ref.hex,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      onChange = _ref.onChange;

  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _chunkB2edacfb.l)(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      (0, _colorutils997790c.b)(data.hex) && onChange({
        hex: data.hex,
        source: "hex"
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: "rgb"
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 1) {
        data.a = 1;
      }

      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: Math.round(data.a * 100) / 100,
        source: "rgb"
      }, e);
    } else if (data.h || data.s || data.l) {
      if (typeof data.s === "string" && data.s.includes("%")) {
        data.s = data.s.replace("%", "");
      }

      if (typeof data.l === "string" && data.l.includes("%")) {
        data.l = data.l.replace("%", "");
      }

      onChange({
        h: data.h || hsl.h,
        s: Number(data.s && data.s || hsl.s),
        l: Number(data.l && data.l || hsl.l),
        source: "hsl"
      }, e);
    }
  };

  var handleClick = function handleClick(color, e) {
    handleChange(color, e);
    setSelected(color);
  };

  var getColors = function getColors(color) {
    if (color.hex) {
      return color.hex;
    } else if (color.r || color.g || color.b) {
      return "rgb(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(color.a || 1, ")");
    } else if (color.h || color.s || color.l) {
      return "hsl(".concat(color.h, ", ").concat(color.s, "%, ").concat(color.l, "%)");
    }
  };

  return swatches.map(function (color, i) {
    return _react.default.createElement(Circle, {
      key: "".concat(color, "-").concat(i),
      className: "".concat(JSON.stringify(selected) === JSON.stringify(color) && "selected"),
      color: getColors(color),
      onClick: function onClick(e) {
        return handleClick(color, e);
      }
    });
  });
};

var Circle = _styledComponents.default.div.withConfig({
  displayName: "ColorPickerSwatches__Circle",
  componentId: "sc-12sj0s8-0"
})(_templateObject(), function (props) {
  return props.color;
}, function (props) {
  return props.theme["$blue"];
}, function (props) {
  return props.theme["$blue"];
});

var _default = ColorPickerSwatches;
exports.default = _default;